import _implicitStylesheets from "./editDropDown.css";

import _implicitScopedStylesheets from "./editDropDown.scoped.css?scoped=true";

import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, k: api_key, d: api_dynamic_text, t: api_text, h: api_element, i: api_iterator, f: api_flatten} = $api;
  return [api_element("select", {
    classMap: {
      "slds-select": true,
      "data-select": true
    },
    styleDecls: [["width", "auto", false]],
    attrs: {
      "id": api_scoped_id("selectDropdown")
    },
    key: 0
  }, api_flatten([api_iterator($cmp.dropdowns, function (p) {
    return api_element("option", {
      attrs: {
        "value": p.value
      },
      key: api_key(1, p.label)
    }, [api_text(api_dynamic_text(p.label))]);
  }), api_iterator($cmp.defaultDropdown, function (p) {
    return api_element("option", {
      styleDecls: [["background-color", "#add8e6", false]],
      attrs: {
        "value": p.value
      },
      key: api_key(2, p.label)
    }, [api_text(api_dynamic_text(p.label))]);
  }), api_element("option", {
    styleDecls: [["background-color", "#add8e6", false]],
    attrs: {
      "value": "None"
    },
    key: 3
  }, [api_text(api_dynamic_text($cmp.title))]), api_element("option", {
    styleDecls: [["background-color", "#add8e6", false]],
    attrs: {
      "value": "Edit"
    },
    key: 4
  }, [api_text("Edit")])])), api_element("div", {
    classMap: {
      "editDropdownPanel": true
    },
    context: {
      lwc: {
        dom: "manual"
      }
    },
    key: 5
  }, [])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-editDropDown_editDropDown"
